// extracted by mini-css-extract-plugin
module.exports = {"industries-sec":"JobsByStates_industries-sec__F1a_6"};